import { CheckboxInput, useFormContextRequired } from "ui-builder";
import { get } from "lodash";
import React, { useMemo } from "react";
import ReactDOM from "react-dom";

export function SelectAllFilterOptionsCheckboxPortal(props: {
  source: string
}) {
  return (<span id={`${props.source}-portal`} />);
}

export function SelectAllFilterOptionsCheckbox(
  props: {
    allOptions: number[],
    source: string
  }
) {

  const formContext = useFormContextRequired();

  const currentValue = get(formContext.data, props.source);

  const isChecked = useMemo(() => {
    return !currentValue || currentValue.length >= props.allOptions.length;
  }, [JSON.stringify(currentValue), props.allOptions.length]);

  const onChangeCallback = () => {
    if (isChecked) {
      formContext.onChangeCallback({
        [props.source]: [],
      })
    } else {
      formContext.onChangeCallback({
        [props.source]: props.allOptions,
      })
    }
  }

  const portalElement = document.getElementById(`${props.source}-portal`);

  if (portalElement) {
    return ReactDOM.createPortal(
      <CheckboxInput
        source="items"
        value={isChecked}
        onChangeCallback={onChangeCallback}
        label="All"
      />,
      portalElement
    );
  } else {
    return null;
  }
}
